var map = {
	"./blog.yml": 188,
	"./cloud.yml": 189,
	"./color.yml": 190,
	"./country.yml": 191,
	"./dio.yml": 192,
	"./doc.yml": 193,
	"./emoji.yml": 194,
	"./git.yml": 195,
	"./icon.yml": 196,
	"./license.yml": 197,
	"./link.yml": 198,
	"./metrics.yml": 199,
	"./people.yml": 200,
	"./soft.yml": 201,
	"./src.yml": 202,
	"./status.yml": 203
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 187;